import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadIoTCoreAdminSystemInfo } from './config';

const rootElement = document.getElementById('root') as HTMLElement;

// Config comes from the sidecar at runtime, so it has to be in place before any
// component renders or any request goes out. Everything downstream reads
// IoTCoreAdminSystemInfo synchronously on the strength of this.
loadIoTCoreAdminSystemInfo().then(
  () => {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  },
  (error: Error) => {
    // Without config there is no admin system to talk to, so fail visibly rather than
    // mounting an app whose every request would fail.
    console.error('Unable to start IoT Core', error);
    rootElement.textContent = `Unable to start: ${error.message}`;
  },
);
